import { render } from "./droneControl.vue?vue&type=template&id=1ec076a4&scoped=true"
import script from "./droneControl.vue?vue&type=script&lang=js"
export * from "./droneControl.vue?vue&type=script&lang=js"

import "./droneControl.vue?vue&type=style&index=0&id=1ec076a4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec076a4"]])

export default __exports__